import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getData'
})
export class GetDataPipe implements PipeTransform {
  transform(value: any, callback: any, ...args: any[]): string {
    return callback(value, ...args);
  }
}
